import social from "@/api/social";
import { useGameContext } from "@/game/GameContext";
import type { Player } from "@/game/types/Game";
import type { ProcessedSpectator } from "@/local-shared/model";
import UIListener from "@/pages/home/UIListener";
import { useEffect, useLayoutEffect, useState } from "react";
import RealizeIcon from "@/assets/img/r-icon.svg?react";
import { generateUsername } from "@/util/UserGen";

const TabButton = ({
    text,
    active,
    onClick,
}: {
    text: string;
    active: boolean;
    onClick?: () => void;
}) =>
{
    return (
        <button
            className={
                active
                    ? Wind.style({
                        color: "text-dark-blue",
                        borderBottomColor: "border-b-sharp-red",
                        borderBottomWidth: "border-b-2",
                        fontWeight: "font-bold",
                        fontSize: "text-base",
                        lineHeight: "leading-6",
                    }).class
                    : Wind.style({
                        color: "text-secondary-gray",
                        fontWeight: "font-bold",
                        fontSize: "text-base",
                        lineHeight: "leading-6",
                        borderBottomWidth: "border-b-2",
                    }).class
            }
            onClick={onClick}
        >
            {text}
        </button>
    );
};

// function getTabContent(tab: "players" | "spectatorList", players: Player[], spectators: any[]) {

export default function WebviewPlayerList({ players }: { players: Player[] })
{
    const { room } = useGameContext();
    const [maxHeight, setMaxHeight] = useState(0);

    const [currentTab, setCurrentTab] = useState<"players" | "spectatorList">(
        "players"
    );

    const [spectators, setSpectators] = useState<ProcessedSpectator[]>([]);

    const { rules } = useGameContext();

    void players;

    useLayoutEffect(() =>
    {
        const currentSize = document.getElementById(
            "playerListContainer"
        )?.clientHeight;

        const currentTabsSize
            = document.getElementById("playerListTabs")?.clientHeight;

        if (currentSize && currentTabsSize)
        {
            setMaxHeight(currentSize - currentTabsSize);
        }
    }, [setMaxHeight]);

    window.addEventListener("resize", () =>
    {
        const currentSize = document.getElementById(
            "playerListContainer"
        )?.clientHeight;

        const currentTabsSize
            = document.getElementById("playerListTabs")?.clientHeight;

        if (currentSize && currentTabsSize)
        {
            setMaxHeight(currentSize - currentTabsSize);
        }
    });

    useEffect(() =>
    {
        switch (currentTab)
        {
            case "spectatorList":
                // Load new spectator list data
                social.rooms
                    .getSpectators(room.id)
                    .then((data) =>
                    {
                        Logger.log(data.spectators);
                        setSpectators(data.spectators);
                    })
                    .catch((error) =>
                    {
                        Logger.error("Failed to load spectators", error);
                    });

                break;
            case "players":
                break;
        }
    }, [currentTab, room.id]);

    useEffect(() =>
    {
        const handleRealtimeSpectatorList = (data: unknown) =>
        {
            const spectatorsData = data as ProcessedSpectator[];

            Logger.log("Realtime Spectator List Update", spectatorsData);
            setSpectators(spectatorsData);
        };

        UIListener.listen("spectatorList", handleRealtimeSpectatorList);

        return () =>
        {
            UIListener.unlisten("spectatorList", handleRealtimeSpectatorList);
        };
    }, []);

    const getTabContent = () =>
    {
        switch (currentTab)
        {
            case "players":
                return (
                    <div
                        className={
                            Wind.style({
                                display: "flex",
                                flexDirection: "flex-col",
                                gap: "gap-4",
                                padding: "p-4",
                            }).class
                        }
                    >
                        {players.map((player) =>
                        {
                            return (
                                <div
                                    key={player.id}
                                    className={
                                        Wind.style({
                                            display: "flex",
                                            flexDirection: "flex-row",
                                            gap: "gap-2",
                                            alignItems: "items-center",
                                            justifyContent: "justify-between",
                                        }).class
                                    }
                                >
                                    <div
                                        className={
                                            Wind.style({
                                                display: "flex",
                                                alignItems: "items-center",
                                                gap: "gap-2",
                                            }).class
                                        }
                                    >
                                        <img
                                            src={player.avatar.path}
                                            alt={`Avatar of ${player.name}`}
                                            className={
                                                Wind.style({
                                                    width: "w-6",
                                                    height: "h-6",
                                                    borderRadius:
                                                        "rounded-full",
                                                }).class
                                            }
                                        />
                                        <span
                                            className={
                                                Wind.style({
                                                    color: "text-dark-blue",
                                                    fontFamily: "font-default",
                                                    fontWeight: "font-medium",
                                                    fontSize: "text-base",
                                                    lineHeight: "leading-6",
                                                }).class
                                            }
                                        >
                                            {player.name}
                                        </span>
                                    </div>
                                    <div
                                        className={
                                            Wind.style({
                                                display: "flex",
                                                alignItems: "items-baseline",
                                            }).class
                                        }
                                    >
                                        <span
                                            className={
                                                Wind.style({
                                                    color: "text-dark-blue",
                                                    fontFamily: "font-default",
                                                    fontWeight: "font-bold",
                                                    fontSize: "text-xl",
                                                    lineHeight: "leading-6",
                                                    marginRight: "mr-1",
                                                }).class
                                            }
                                        >
                                            {player.score}
                                        </span>
                                        <span
                                            className={
                                                Wind.style({
                                                    fontFamily: "font-default",
                                                    fontWeight: "font-light",
                                                    fontSize: "text-xs",
                                                    lineHeight: "leading-6",
                                                }).class
                                            }
                                        >
                                            {` / ${rules.pointsToWin} pts`}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            case "spectatorList":
                return (
                    <div
                        className={
                            Wind.style({
                                display: "flex",
                                flexDirection: "flex-col",
                                gap: "gap-4",
                                padding: "p-4",
                            }).class
                        }
                    >
                        {spectators.map((spectator) =>
                        {
                            Logger.log(spectator);

                            return (
                                <div
                                    key={spectator.spectator_id}
                                    className={
                                        Wind.style({
                                            display: "flex",
                                            flexDirection: "flex-row",
                                            gap: "gap-2",
                                            alignItems: "items-center",
                                        }).class
                                    }
                                >
                                    {spectator.profile === null ? (
                                        <RealizeIcon
                                            className={
                                                Wind.style({
                                                    width: "w-6",
                                                    height: "h-6",
                                                    borderRadius:
                                                        "rounded-full",
                                                    backgroundColor:
                                                        "bg-dark-blue",
                                                    color: "text-white",
                                                    padding: "p-1",
                                                }).class
                                            }
                                        />
                                    ) : (
                                        <img
                                            src={spectator.profile.photo_path}
                                            alt=""
                                            className={
                                                Wind.style({
                                                    width: "w-6",
                                                    height: "h-6",
                                                    borderRadius:
                                                        "rounded-full",
                                                    objectFit: "object-cover",
                                                }).class
                                            }
                                        />
                                    )}
                                    <span
                                        className={
                                            Wind.style({
                                                color: "text-dark-blue",
                                                fontFamily: "font-default",
                                                fontWeight: "font-medium",
                                                fontSize: "text-base",
                                                lineHeight: "leading-6",
                                            }).class
                                        }
                                    >
                                        {spectator.profile === null
                                            ? generateUsername(
                                                parseInt(
                                                    spectator.spectator_id.toString(),
                                                    10
                                                )
                                            )
                                            : spectator.profile.username}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                );
        }
    };

    return (
        <div
            id="playerListContainer"
            className={
                Wind.style({
                    flexGrow: "grow",
                    backgroundColor: "bg-[#F9F5ED]",
                    borderRadius: "rounded-lg",
                    display: "flex",
                    flexDirection: "flex-col",
                    overflow: "overflow-hidden",
                }).class
            }
        >
            <div
                id="playerListTabs"
                className={
                    Wind.style({
                        display: "flex",
                        flexDirection: "flex-row",
                        gap: "gap-6",
                        padding: "p-4",
                        borderBottomColor: "border-b-[#EBE2D5]",
                        borderBottomWidth: "border-b-2",
                    }).class
                }
            >
                <TabButton
                    text="Players"
                    active={currentTab === "players"}
                    onClick={() => void setCurrentTab("players")}
                />
                <TabButton
                    text={`Spectators (${spectators.length})`}
                    active={currentTab === "spectatorList"}
                    onClick={() => void setCurrentTab("spectatorList")}
                />
            </div>
            <div
                className="flex-grow"
                style={{
                    maxHeight: `${maxHeight}px`,
                }}
            >
                <div className="h-full overflow-y-auto">
                    {maxHeight > 0 && getTabContent()}
                </div>
            </div>
        </div>
    );
}
